import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import DATA_TEST_IDS from 'chameleon-src/components/assign/AssignManageForm/utils/dataTestIds';

/**
 * Display `View` link for in progress assignment.
 * */
export const ProgressLink = ({
  sectionName,
  progressRoute,
  assignmentId,
  isaNotation,
  isAssessmentForm,
}) => (
  <div className="flex-row space-between width-100 text-14 mb-4">
    <div data-test-id={DATA_TEST_IDS.PROGRESS_NAME_CONTAINER}>
      <div data-test-id={DATA_TEST_IDS.PROGRESS_SECTION_NAME}>
        {sectionName}
      </div>
      {isaNotation && (
        <div data-test-id={DATA_TEST_IDS.PROGRESS_ISA_NOTATION}>
          {isaNotation.trim()}
        </div>
      )}
    </div>
    {isAssessmentForm && (
      <Link
        data-test-id={DATA_TEST_IDS.PROGRESS_LINK}
        to={progressRoute.replace(':assignmentId', assignmentId)}
      >
        View
      </Link>
    )}
  </div>
);

ProgressLink.propTypes = {
  sectionName: PropTypes.string.isRequired,
  progressRoute: PropTypes.string.isRequired,
  assignmentId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
};

ProgressLink.defaultProps = {
  isaNotation: null,
};

export default ProgressLink;
